import Echo from "laravel-echo";
window.Pusher = require("pusher-js");

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token");
let client_server_url = urlParams.get("server_url");

if (client_server_url && client_server_url.startsWith("http://")) {
  client_server_url = client_server_url.replace("http://", "https://");
}

// window.Pusher.logToConsole = true;

const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.VUE_APP_WEBSOCKETS_KEY,
  cluster: process.env.VUE_APP_WEBSOCKETS_CLUSTER, // e.g. "ap2"
  forceTLS: true,
  disableStats: true,
  authEndpoint: `${client_server_url}/api/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  },
});

export default echo;
